import {
  getTestConfigs,
  createTestConfig,
  updateTestConfig,
  activateTestConfig,
} from '../../shared/services/apiService';

export const EMPTY_CONFIG = {
  title: '', description: '', total_questions: 10,
  duration_minutes: 30, passing_marks: 60, max_violations: 3,
  randomize_questions: true, category_distribution: [],
};

// ── Load all test configurations ──────────────────────────────────────────────
export const loadTestConfigs = async () => {
  const res = await getTestConfigs();
  return res.data.data.configs;
};

// ── Save (create or update) a test config ────────────────────────────────────
export const saveTestConfig = async (formData, editId) => {
  if (editId) {
    await updateTestConfig(editId, formData);
    return 'updated';
  }
  await createTestConfig(formData);
  return 'created';
};

// ── Set a config as the active one ───────────────────────────────────────────
export const setActiveConfig = async (id) => {
  await activateTestConfig(id);
};
